import React from "react";

import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';





const Tab = createBottomTabNavigator();


import {RFValue} from "react-native-responsive-fontsize";



import Config from "../../Config";



import { Ionicons} from "@expo/vector-icons";

import HomeTab from "./Tab/HomeTab";
import {Platform} from "react-native";



import Feather from '@expo/vector-icons/Feather';
import AntDesign from '@expo/vector-icons/AntDesign';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import Octicons from '@expo/vector-icons/Octicons';
import Other from "./Tab/Other";
import Newcourses from "./Tab/Newcourses";
import Tamrin from "./Tab/Tamrin";


const Home = ({navigation})=>{
    const stack = navigation;

    let height = RFValue(70);
    let pading = RFValue(10);

    if (Platform.OS == 'web') {
         height = RFValue(99);
         pading = RFValue(5);
    }




    return (
        <Tab.Navigator
            screenOptions={{
                headerShown : false,
                tabBarShowLabel: true,
                tabBarLabelStyle : {
                    fontFamily : 'yk',
                    fontSize : RFValue(10),
                    marginBottom :RFValue(2),
                    color : 'white',
                    marginTop : pading,
                },
                tabBarIconStyle : {
                   height : RFValue(35),
                },
                tabBarStyle: {
                    height: height ,
                    backgroundColor: '#000422',
                },
            }}

        >
            <Tab.Screen  options={{
                tabBarLabel: 'خانه',
                tabBarIcon: ({ color, size, focused }) => (
                    <Octicons style={{marginBottom: -RFValue(6)}} name="home" color={ focused ? Config.secondcolor:'white'} size={ focused ? RFValue(size + 3) : RFValue(size - 2)} />
                ),

                // tabBarBadge: 3,
            }}
                         name="HomeScreen"
                // component={HomeScreen}
                         children={() => <HomeTab   stack={stack} />}
            />
            <Tab.Screen options={{
                tabBarLabel: ' دوره های جدید ',
                tabBarIcon: ({ color, size, focused }) => (
                    <Feather name="book-open" color={ focused ? Config.secondcolor:'white'} size={ focused ? RFValue(size + 3) : RFValue(size -2)} />
                ),

                // tabBarBadge: 3,
            }} name="Categories" component={Newcourses} />

            <Tab.Screen options={{
                tabBarLabel: 'تمرین و تکرار',
                tabBarIcon: ({ color, size, focused }) => (
                    <MaterialCommunityIcons name="dumbbell"   color={ focused ? Config.secondcolor:'white'} size={ focused ? RFValue(size + 3) : RFValue(size -2)} />
                ),
                // tabBarBadge: 3,
            }} name="Tamrin" component={Tamrin} />



            <Tab.Screen options={{
                tabBarLabel: 'سایر',
                tabBarIcon: ({ color, size, focused }) => (
                    <AntDesign name="appstore-o"   color={ focused ? Config.secondcolor:'white'} size={ focused ? RFValue(size + 3) : RFValue(size -2)} />
                ),
                // tabBarBadge: 3,
            }} name="Other" component={Other} />


        </Tab.Navigator>
    );




}

export default Home;
